// OTP is now handled fully by Firebase Phone Authentication on the client side.
// This module is kept as a thin re-export so that any remaining callers compile.
// See lib/firebase-otp.ts for the actual send/confirm functions.

export { sendFirebaseOtp as sendOtp, confirmFirebaseOtp as confirmOtp } from '../firebase-otp';
